import styled from 'styled-components';

export const StyledInteriorPackageContainer = styled.div`
	margin-top: 24px;
`;
